import { render } from "./Conversion.vue?vue&type=template&id=36f97156&scoped=true"
import script from "./Conversion.vue?vue&type=script&lang=js"
export * from "./Conversion.vue?vue&type=script&lang=js"

import "./Conversion.vue?vue&type=style&index=0&id=36f97156&lang=css"
import "./Conversion.vue?vue&type=style&index=1&id=36f97156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f97156"]])

export default __exports__